import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/product-1.jpg'
import _imports_1 from '@/assets/images/product-2.jpg'
import _imports_2 from '@/assets/images/product-3.jpg'
import _imports_3 from '@/assets/images/product-4.jpg'
import _imports_4 from '@/assets/images/product-5.jpg'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "default-table-area all-carts" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_QuantityCounter = _resolveComponent("QuantityCounter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-lg-4 mb-3" }, [
        _createElementVNode("h3", { class: "mb-0" }, "Recent Orders"),
        _createElementVNode("h3", { class: "mb-0" }, "Customer ID : 357951")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[20] || (_cache[20] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, "Order ID"),
                _createElementVNode("th", { scope: "col" }, "Product"),
                _createElementVNode("th", { scope: "col" }, "Quantity"),
                _createElementVNode("th", { scope: "col" }, "Price"),
                _createElementVNode("th", { scope: "col" }, "Total")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[1] || (_cache[1] = _createElementVNode("td", { class: "text-secondary" }, "#JAN-2345", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/ecommerce/product-details",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        class: "wh-40 rounded-3",
                        alt: "product-1"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2 ps-1" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14 mb-0" }, "Smart Band")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_QuantityCounter)
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("td", { class: "text-body" }, "$80.00", -1)),
                _cache[3] || (_cache[3] = _createElementVNode("td", { class: "text-body" }, "$80.00", -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[5] || (_cache[5] = _createElementVNode("td", { class: "text-secondary" }, "#JAN-1323", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/ecommerce/product-details",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createElementVNode("img", {
                        src: _imports_1,
                        class: "wh-40 rounded-3",
                        alt: "product-1"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2 ps-1" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14 mb-0" }, "Headphone")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_QuantityCounter)
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("td", { class: "text-body" }, "$150.00", -1)),
                _cache[7] || (_cache[7] = _createElementVNode("td", { class: "text-body" }, "$450.00", -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[9] || (_cache[9] = _createElementVNode("td", { class: "text-secondary" }, "#DEC-1234", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/ecommerce/product-details",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createElementVNode("img", {
                        src: _imports_2,
                        class: "wh-40 rounded-3",
                        alt: "product-1"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2 ps-1" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14 mb-0" }, "iPhone 15 Plus")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_QuantityCounter)
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("td", { class: "text-body" }, "$750.00", -1)),
                _cache[11] || (_cache[11] = _createElementVNode("td", { class: "text-body" }, "$750.00", -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[13] || (_cache[13] = _createElementVNode("td", { class: "text-secondary" }, "#DEC-3567", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/ecommerce/product-details",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createElementVNode("img", {
                        src: _imports_3,
                        class: "wh-40 rounded-3",
                        alt: "product-1"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2 ps-1" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14 mb-0" }, "Bluetooth Speaker")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_QuantityCounter)
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("td", { class: "text-body" }, "$15.00", -1)),
                _cache[15] || (_cache[15] = _createElementVNode("td", { class: "text-body" }, "$75.00", -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[17] || (_cache[17] = _createElementVNode("td", { class: "text-secondary" }, "#DEC-1098", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/ecommerce/product-details",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createElementVNode("img", {
                        src: _imports_4,
                        class: "wh-40 rounded-3",
                        alt: "product-1"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2 ps-1" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14 mb-0" }, "Airbuds 2nd Gen")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_QuantityCounter)
                ]),
                _cache[18] || (_cache[18] = _createElementVNode("td", { class: "text-body" }, "$25.00", -1)),
                _cache[19] || (_cache[19] = _createElementVNode("td", { class: "text-body" }, "$50.00", -1))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}